module.exports = __webpack_public_path__ + "img/lg_ring_g_c_0_1@3x.84f3d89a.png";